import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_d2f1a296-f421-4ca2-ae61-9d54acaa8e8a/artifacts/em50v0eb_Logo.png";

const NAV_ITEMS = [
  { label: "The Difference", href: "#difference" },
  { label: "Coffee", href: "#credibility" },
  { label: "Experience", href: "#why" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-[color:var(--fs-hairline)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <img
            src={LOGO_URL}
            alt="Flow State Coffee"
            className="h-11 w-11 object-contain"
          />
          <span className="font-display text-lg tracking-brand uppercase text-gold-foil hidden sm:inline">
            Flow State
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.href.replace("#", "")}`}
              className="link-wave text-[11px] tracking-[0.22em] uppercase text-neutral-400 hover:text-[color:var(--fs-gold-hi)] transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href="#product"
            data-testid="nav-shop-cta"
            className="btn-ghost-gold"
          >
            Shop Now
          </a>
        </div>

        <button
          className="md:hidden text-[color:var(--fs-gold-muted)]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden border-t border-[color:var(--fs-hairline)] bg-black/95 backdrop-blur-xl"
          data-testid="nav-mobile-menu"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="text-xs tracking-[0.22em] uppercase text-neutral-400"
                data-testid={`nav-mobile-${item.href.replace("#", "")}`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#product"
              onClick={() => setOpen(false)}
              className="btn-ghost-gold w-fit"
              data-testid="nav-mobile-shop"
            >
              Shop Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
